import { clientReloadReason, isClientReloadRequired } from '../../../utils/clientReload';
export function assertMessagingWriteAllowed() {
  if (!isClientReloadRequired()) return;
  throw Object.assign(new Error(clientReloadReason() === 'shared-only' ? 'Chat settings changed. Reload to continue.' : 'This screen is out of date. Reload the page to continue.'), {
    code: 'MESSAGING_CLIENT_RELOAD_REQUIRED', status: 409, retryable: false, localPolicyChange: clientReloadReason() === 'shared-only',
  });
}
